import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, map, Observable} from "rxjs";
import {ResponseHttpSuccess} from "library";
import {environment} from "projects/store/src/environments/environment";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  url: string = environment.apiURL;
  updatedUserObservable: Observable<boolean>;
  updatedUserSubject: BehaviorSubject<boolean>;

  constructor(private http: HttpClient,
              private authService: AuthService) {
    this.updatedUserSubject = new BehaviorSubject<boolean>(false);
    this.updatedUserObservable = this.updatedUserSubject.asObservable();
  }

  get(id: string) {
    return this.http.get(`${this.url}merchant/user/${id}`, this.authService.getHttpOptionsBearer())
      .pipe(map(resp => {
        // TODO solucion temporal, mientras no se sube la solucion en el admin
        let response = resp as ResponseHttpSuccess;
        if(response.body.data.store != null && response.body.data.store.setting != null) {
          response.body.data.store.setting.enabled_view_otp_by_document = true;
        }
        return response;
      }));
  }

  updateStore(userId: string, storeId: string) {
    const url = 'https://daniel-develop-colombia-krediya-api-gateway-sfnpiy3jcq-ue.a.run.app/v1/';
    return this.http.patch(`${this.url}merchant/user/${userId}`, { store_id: storeId }, this.authService.getHttpOptionsBearer())
      .pipe(map(resp => resp as ResponseHttpSuccess));
  }
}
